import { registerEnumType } from 'type-graphql'

export enum DocumentLinkTypeEnum {
  Order = 'Order',
  PurchaseOrder = 'PurchaseOrder',
  LogisticPackingSlip = 'LogisticPackingSlip',
  OrderPackingSlip = 'OrderPackingSlip',
  HaulerManifest = 'HaulerManifest',
  PaymeInvoice = 'PaymeInvoice',
}

registerEnumType(DocumentLinkTypeEnum, {
  name: 'DocumentLinkTypeEnum',
  description: 'The documents a public tokenised link can open',
})
